// Header data for customized rewards table
export const customizedRewardsHeaderData = [
  {
    columnKey: "status",
    header: "Status",
  },
  {
    columnKey: "name",
    header: "Name",
  },
  {
    columnKey: "quantity",
    header: "Quantity",
  },
  {
    columnKey: "campaignsIncluded",
    header: "Campaigns Included",
  },
  {
    columnKey: "rewards",
    header: "Rewards",
  },

  {
    columnKey: "startDate",
    header: "Start Date",
  },
  {
    columnKey: "endDate",
    header: "End Date",
  },
  {
    columnKey: "action",
    header: "Action",
  },
];
